import { Button } from "@/components/button";
import { useImpersonate } from "@/hooks/useImpersonate";

export function ImpersonateButton({
  currentProjectId,
  id,
}: {
  currentProjectId?: null | number;
  id: string;
}) {
  const impersonateMutation = useImpersonate();

  return (
    <Button
      className="text-xs"
      isDisabled={impersonateMutation.isPending}
      onPress={() =>
        impersonateMutation.mutate({
          targetUserCurrentProjectId: currentProjectId,
          targetUserId: Number(id),
        })
      }
      size="sm"
      variant="secondary"
    >
      Impersonate
    </Button>
  );
}
